import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const countryService = {
  getCountries: async () => {
    try {
      console.log('Fetching countries from:', `${config.API_URL}/countries`);
      const response = await api.get('/countries');
      console.log('Countries response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  },

  getCountryById: async (id) => {
    const response = await api.get(`/countries/${id}`);
    return response.data;
  },

  addCountry: async (formData) => {
    const data = new FormData();
    data.append('name', formData.name);
    if (formData.coverImage) {
      data.append('coverImage', formData.coverImage);
    }
    
    console.log('Sending data:', formData); // Debug için

    // Token'ı manuel olarak ekle
    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await api.post('/countries', data, { headers });
    console.log('Response:', response.data);
    return response.data;
  },

  deleteCountry: async (id) => {
    const response = await api.delete(`/countries/${id}`);
    return response.data;
  }
};

export default countryService;